var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09607 7.59851L2.61708 8.17563C1.67885 7.39693 1.125 6.24333 1.125 5.00007C1.125 3.75853 1.67731 2.60636 2.61332 1.82764L3.09299 2.40419C2.32648 3.0419 1.875 3.98372 1.875 5.00007C1.875 6.01782 2.32774 6.96082 3.09607 7.59851ZM7.40393 7.59851L7.88292 8.17563C8.82115 7.39693 9.375 6.24333 9.375 5.00007C9.375 3.75853 8.82269 2.60636 7.88668 1.82764L7.40701 2.40419C8.17352 3.0419 8.625 3.98372 8.625 5.00007C8.625 6.01782 8.17226 6.96082 7.40393 7.59851ZM6.44194 6.44753L6.91909 7.02618C7.51982 6.53081 7.875 5.79408 7.875 5.00007C7.875 4.20867 7.52216 3.4741 6.92479 2.97868L6.44602 3.55598C6.87336 3.91039 7.125 4.43427 7.125 5.00007C7.125 5.56772 6.87169 6.09316 6.44194 6.44753ZM3.58091 7.02618L4.05806 6.44753C3.62831 6.09316 3.375 5.56772 3.375 5.00007C3.375 4.43427 3.62664 3.91039 4.05398 3.55598L3.57521 2.97868C2.97784 3.4741 2.625 4.20867 2.625 5.00007C2.625 5.79408 2.98018 6.53081 3.58091 7.02618Z",
    fill: "#8A94A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 5.85949C5.95611 5.71482 6.1875 5.38443 6.1875 5C6.1875 4.48223 5.76777 4.0625 5.25 4.0625C4.73223 4.0625 4.3125 4.48223 4.3125 5C4.3125 5.38443 4.54389 5.71482 4.875 5.85949V8C4.875 8.20711 5.04289 8.375 5.25 8.375C5.45711 8.375 5.625 8.20711 5.625 8V5.85949Z",
    fill: "#8A94A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCell);
export default __webpack_public_path__ + "static/media/cell.e078e866c10c9102961ba215cf155ecc.svg";
export { ForwardRef as ReactComponent };